import { reducedStream, reducer } from '@ardoq/rxbeach';
import { selectedViewOperations } from './operations';
import { setSelectedView, resetSelectedView } from './actions';
import { Observable } from 'rxjs';
import { SelectedViewState } from './types';

export const createSelectedView$ = (
  namespace: string
): Observable<SelectedViewState> =>
  reducedStream<SelectedViewState>(
    `viewpointBuilder2.0/selectView$:${namespace}`,
    selectedViewOperations.getDefaultState(),
    [
      reducer(setSelectedView, selectedViewOperations.setSelectedView),
      reducer(resetSelectedView, selectedViewOperations.getDefaultState),
    ],
    { namespace }
  );
